import { styled } from '@/styled-system/jsx';

export const Container = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    overflow: 'hidden',
    width: 'fit-content',
    boxShadow: '0 1px 3px hpHoverState',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'hpxGrey400',
  },
});

export const Button = styled('button', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'hpxGrey100',
    border: 'none',
    height: '36px',
    width: '36px',
    cursor: 'pointer',
    color: 'hpxBlue600',
    transitionProperty: 'background-color, outline',
    transitionDuration: '0.2s, 0.2s',
    position: 'relative',
    padding: 0,

    '&:first-of-type': {
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
    },

    '&:last-of-type': {
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px',
    },

    _hover: {
      backgroundColor: 'hpxGrey400',
    },

    _active: {
      backgroundColor: 'hpxGrey500',
      boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)',
    },

    '&:active': {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxBlue500',
      outlineOffset: '-2px',
      zIndex: 1,
    },

    _disabled: {
      cursor: 'not-allowed',
      color: 'hpxGrey500',
      backgroundColor: '#f8f8f8',
    },

    '&:focus': {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxBlue500',
      outlineOffset: '-2px',
      zIndex: 1,
    },

    _focus: {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxBlue500',
      outlineOffset: '-2px',
      zIndex: 1,
    },

    '&:focus-visible': {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxBlue500',
      outlineOffset: '-2px',
      backgroundColor: 'hpxGrey400',
      zIndex: 1,
    },

    _focusVisible: {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxBlue500',
      outlineOffset: '-2px',
      backgroundColor: 'hpxGrey400',
      zIndex: 1,
    },
  },
});

export const IconWrapper = styled('span', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
  },
});

export const Input = styled('input', {
  base: {
    width: '50px',
    height: '36px',
    textAlign: 'center',
    border: 'none',
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'hpxGrey400',
    borderRightWidth: '1px',
    borderRightStyle: 'solid',
    borderRightColor: 'hpxGrey400',
    fontSize: 'sm',
    paddingX: '1x',
    paddingY: '0',
    appearance: 'textfield',
    position: 'relative',

    '&:focus': {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxBlue500',
      outlineOffset: '-2px',
      zIndex: 1,
    },

    _focus: {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxBlue500',
      outlineOffset: '-2px',
      zIndex: 1,
    },

    _readOnly: {
      cursor: 'default',
    },

    // Hide spinner buttons for number input
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: '0',
    },
  },
});
